import { ByCategory } from './types';

export default function getTagOptions(
  tags: {
    category: string | null;
    title: string | null;
    id: number | null;
  }[]
) {
  const optionIds = tags.map(({ id }) => id);

  const optionsByKey = tags.reduce((acc: ByCategory<number[]>, tag) => {
    if (tag.category && tag.id) {
      acc[tag.category] = [...(acc[tag.category] || []), tag.id];
    }
    return acc;
  }, {});

  const optionKeys = Object.keys(optionsByKey);

  return {
    optionIds,
    optionKeys,
    optionsByKey,
  };
}
